export default {
  zoomInLabel: {
    id: 'rm_map_zoom_in',
    defaultMessage: 'Zoom in',
  },
  zoomOutLabel: {
    id: 'rm_map_zoom_out',
    defaultMessage: 'Zoom out',
  },
} as const
